export interface ArticleMeta {
  slug: string;
  icon: string;
  image: string;
}

export const DEFAULT_ARTICLE_SLUG = "basetao-spreadsheet";

export const articles: ArticleMeta[] = [
  {
    slug: "basetao-spreadsheet",
    icon: "ri-grid-line",
    image:
      "https://readdy.ai/api/search-image?query=Modern%20minimal%20spreadsheet%20dashboard%20interface%20showing%20a%20clean%20table%20with%20product%20rows%20and%20columns%20for%20image%20category%20seller%20price%20and%20quality%20control%20on%20a%20light%20background%20with%20soft%20sage%20green%20accents%20fresh%20editorial%20UI%20design%20high%20detail%20harmonious%20composition&width=800&height=450&seq=guide-spreadsheet-01&orientation=landscape",
  },
  {
    slug: "basetao-review",
    icon: "ri-star-line",
    image:
      "https://readdy.ai/api/search-image?query=Soft%20pastel%20flat%20lay%20photography%20of%20a%20notebook%20with%20five%20star%20rating%20stickers%20and%20a%20pen%20on%20a%20light%20sage%20green%20background%20with%20soft%20natural%20daylight%20and%20gentle%20shadows%20airy%20minimal%20editorial%20aesthetic%20high%20detail%20harmonious%20composition&width=800&height=450&seq=guide-review-01&orientation=landscape",
  },
  {
    slug: "basetao-shipping-cost",
    icon: "ri-truck-line",
    image:
      "https://readdy.ai/api/search-image?query=Soft%20pastel%20flat%20lay%20photography%20of%20a%20small%20cardboard%20shipping%20box%20with%20a%20tape%20measure%20and%20a%20weight%20scale%20on%20a%20light%20sage%20green%20background%20with%20soft%20natural%20daylight%20and%20gentle%20shadows%20airy%20minimal%20editorial%20aesthetic%20high%20detail%20harmonious%20composition&width=800&height=450&seq=guide-shipping-01&orientation=landscape",
  },
  {
    slug: "basetao-coupon",
    icon: "ri-coupon-line",
    image:
      "https://readdy.ai/api/search-image?query=Soft%20pastel%20flat%20lay%20photography%20of%20a%20stack%20of%20discount%20coupon%20cards%20with%20a%20scissors%20and%20a%20gift%20tag%20on%20a%20light%20sage%20green%20background%20with%20soft%20natural%20daylight%20and%20gentle%20shadows%20airy%20minimal%20editorial%20aesthetic%20high%20detail%20harmonious%20composition&width=800&height=450&seq=guide-coupon-01&orientation=landscape",
  },
  {
    slug: "basetao-discount-code",
    icon: "ri-ticket-line",
    image:
      "https://readdy.ai/api/search-image?query=Soft%20pastel%20flat%20lay%20photography%20of%20a%20promo%20code%20ticket%20with%20barcode%20and%20a%20smartphone%20showing%20a%20checkout%20screen%20on%20a%20light%20sage%20green%20background%20with%20soft%20natural%20daylight%20and%20gentle%20shadows%20airy%20minimal%20editorial%20aesthetic%20high%20detail%20harmonious%20composition&width=800&height=450&seq=guide-discount-01&orientation=landscape",
  },
  {
    slug: "basetao-warehouse",
    icon: "ri-archive-line",
    image:
      "https://readdy.ai/api/search-image?query=Soft%20pastel%20flat%20lay%20photography%20of%20miniature%20warehouse%20shelves%20with%20neatly%20stacked%20cardboard%20boxes%20and%20a%20clipboard%20on%20a%20light%20sage%20green%20background%20with%20soft%20natural%20daylight%20and%20gentle%20shadows%20airy%20minimal%20editorial%20aesthetic%20high%20detail%20harmonious%20composition&width=800&height=450&seq=guide-warehouse-01&orientation=landscape",
  },
  {
    slug: "basetao-legit",
    icon: "ri-shield-check-line",
    image:
      "https://readdy.ai/api/search-image?query=Soft%20pastel%20flat%20lay%20photography%20of%20a%20shield%20icon%20made%20of%20paper%20with%20a%20checkmark%20and%20a%20magnifying%20glass%20on%20a%20light%20sage%20green%20background%20with%20soft%20natural%20daylight%20and%20gentle%20shadows%20airy%20minimal%20editorial%20aesthetic%20high%20detail%20harmonious%20composition&width=800&height=450&seq=guide-legit-01&orientation=landscape",
  },
  {
    slug: "basetao-qc",
    icon: "ri-camera-line",
    image:
      "https://readdy.ai/api/search-image?query=Soft%20pastel%20flat%20lay%20photography%20of%20a%20camera%20with%20printed%20quality%20control%20photo%20prints%20and%20a%20measuring%20tape%20on%20a%20light%20sage%20green%20background%20with%20soft%20natural%20daylight%20and%20gentle%20shadows%20airy%20minimal%20editorial%20aesthetic%20high%20detail%20harmonious%20composition&width=800&height=450&seq=guide-qc-01&orientation=landscape",
  },
  {
    slug: "basetao-sellers",
    icon: "ri-store-line",
    image:
      "https://readdy.ai/api/search-image?query=Soft%20pastel%20flat%20lay%20photography%20of%20a%20storefront%20sign%20made%20of%20paper%20with%20rating%20stars%20and%20a%20magnifying%20glass%20on%20a%20light%20sage%20green%20background%20with%20soft%20natural%20daylight%20and%20gentle%20shadows%20airy%20minimal%20editorial%20aesthetic%20high%20detail%20harmonious%20composition&width=800&height=450&seq=guide-sellers-01&orientation=landscape",
  },
  {
    slug: "basetao-products",
    icon: "ri-shopping-bag-line",
    image:
      "https://readdy.ai/api/search-image?query=Soft%20pastel%20flat%20lay%20photography%20of%20a%20variety%20of%20fashion%20products%20including%20a%20sneaker%20a%20folded%20tee%20and%20a%20small%20bag%20arranged%20on%20a%20light%20sage%20green%20background%20with%20soft%20natural%20daylight%20and%20gentle%20shadows%20airy%20minimal%20editorial%20aesthetic%20high%20detail%20harmonious%20composition&width=800&height=450&seq=guide-products-01&orientation=landscape",
  },
];

export const articleSlugs = articles.map((a) => a.slug);